export default __webpack_public_path__ + "media/images/pumpkin-run-fun-card-title-3537bbe52c08a3e313e96040d0fc4019.svg";